import React from 'react';
import LotPobrezaCronicaSection from './LotPobrezaCronicaSection';
import LotZonaInundableSection from './LotZonaInundableSection';
import LotDetailSectionShell, { LotDetailTable, LotDetailTableRow } from './LotDetailSectionShell';

/**
 * Indicadores territoriales de riesgo y contexto socioeconómico del entorno.
 */
const LotRiesgosSection = ({
  floodRiskPct = null,
  chronicPovertyPct = null,
  blocked = false,
  blockedMessage = 'Iniciá sesión para ver los riesgos del entorno del lote.',
  hideTitle = false,
}) => (
  <LotDetailSectionShell
    title="Riesgos / Contexto"
    hideTitle={hideTitle}
    blocked={blocked}
    blockedMessage={blockedMessage}
  >
    <LotDetailTable>
      <LotDetailTableRow>
        <LotZonaInundableSection floodRiskPct={floodRiskPct} />
      </LotDetailTableRow>
      <LotDetailTableRow hideDivider>
        <LotPobrezaCronicaSection chronicPovertyPct={chronicPovertyPct} />
      </LotDetailTableRow>
    </LotDetailTable>
  </LotDetailSectionShell>
);

export default LotRiesgosSection;
